import type { SVGProps } from 'react'
const SvgSyCamera = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				fillRule="evenodd"
				d="M12 3c-.654 0-1.305.025-1.875.078s-1.03.111-1.443.276c-.759.301-1.18.926-1.467 1.439-.286.513-.531.993-.54 1.002-.23.25-.687.361-.779.361A3.91 3.91 0 0 0 2 10.053v5.795a4.98 4.98 0 0 0 4.97 4.968h10.06A4.98 4.98 0 0 0 22 15.848v-5.795a3.91 3.91 0 0 0-3.896-3.897c-.094 0-.55-.11-.78-.36-.007-.007-.252-.49-.539-1.003s-.708-1.138-1.467-1.44c-.413-.164-.873-.222-1.443-.275S12.654 3 12 3m0 1.5c.614 0 1.23.025 1.736.072s.936.14 1.028.176c.251.1.487.378.71.777.224.4.34.844.745 1.286a2.54 2.54 0 0 0 1.885.845 2.386 2.386 0 0 1 2.396 2.397v5.795a3.46 3.46 0 0 1-3.47 3.468H6.97a3.46 3.46 0 0 1-3.47-3.468v-5.795a2.386 2.386 0 0 1 2.396-2.397c.561 0 1.286-.196 1.883-.845h.002c.406-.442.521-.886.744-1.286.224-.4.46-.677.711-.777.093-.037.52-.128 1.028-.176A19 19 0 0 1 12 4.5"
				clipRule="evenodd"
			/>
			<path d="M17.496 8.7a1 1 0 0 0-1 1 1 1 0 0 0 1 1h.008a1 1 0 0 0 1-1 1 1 0 0 0-1-1z" opacity={0.4} />
			<path
				fillRule="evenodd"
				d="M12 9.398c-2.161 0-3.93 1.769-3.93 3.93s1.769 3.93 3.93 3.93 3.93-1.769 3.93-3.93-1.769-3.93-3.93-3.93m0 1.5c1.35 0 2.43 1.08 2.43 2.43s-1.08 2.43-2.43 2.43-2.43-1.08-2.43-2.43 1.08-2.43 2.43-2.43"
				clipRule="evenodd"
				opacity={0.4}
			/>
		</g>
	</svg>
)
export default SvgSyCamera
